import React from 'react';
import { Button } from 'reactstrap';

/**
 * FooterButton component for individual action buttons in the footer
 * @param {string} id - Unique identifier for the button
 * @param {string|React.Element} icon - Icon emoji, text, or React element to display
 * @param {function} onClick - Click handler function
 * @param {function} onHoverChange - Hover state change handler
 * @param {object} style - Custom styles for the button
 * @param {string} iconColor - Color for the icon
 */
const FooterButton = ({ 
  id, 
  icon, 
  onClick, 
  onHoverChange, 
  style, 
  iconColor,
  className,
  color,
  title,
  ...rest
}) => {
  const handleMouseEnter = () => {
    onHoverChange?.(true);
  };

  const handleMouseLeave = () => {
    onHoverChange?.(false);
  };

  return (
    <Button 
      className={className}
      color={color}
      title={title}
      type="button"
      {...rest}
      style={{
        width: 36,
        height: 36,
        padding: 0,
        borderRadius: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        ...style
      }}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {icon}
    </Button>
  );
};

export default FooterButton; 
